import { TopolDynamicBlock } from "@/schemas/template/blocks/dynamicBlockSchema";
import calcWidth from "./helpers";
import { v4 as uuidv4 } from "uuid";

export default {
  getData(
    state: any,
    props: { sectionIndex: number; columnIndex: number }
  ): TopolDynamicBlock {
    return {
      uid: uuidv4(),
      tagName: "mj-dynamic",
      attributes: {
        containerWidth: calcWidth(
          state.mjml.children[0].attributes["containerWidth"],
          state.mjml.children[0].children[props.sectionIndex].children[
            props.columnIndex
          ].attributes["width"]
        ),
      },
      content: "",
      identifier: "email",
      feed: "",
    };
  },
};
